import axios from 'axios';

import { IAffRespCompteClient } from '@/shared/model/aff-resp-compte-client.model';

const baseApiUrl = 'api/aff-resp-compte-clients';

export default class AffRespCompteClientService {
  public find(id: number): Promise<IAffRespCompteClient> {
    return new Promise<IAffRespCompteClient>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAffRespCompteClient): Promise<IAffRespCompteClient> {
    return new Promise<IAffRespCompteClient>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAffRespCompteClient): Promise<IAffRespCompteClient> {
    return new Promise<IAffRespCompteClient>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
